export default __webpack_public_path__ + "static/media/home_browse_gray.1de87bd3.svg";